import {Injectable} from '@angular/core';
import {NICEUnavailableCode} from '../models/NICE_UnavailableCode.model';
import {GeneralService} from './general.service';
import {AuthService} from './auth.service';
import {map} from 'rxjs/operators';
import {NICETeamAgent} from '../models/NICE_TeamAgent.model';
import {NICEUserSkill} from '../models/NICE_UserSkill.model';
import {NICESkillAgent} from '../models/NICE_SkillAgent.model';
import {IcDataUserService} from './ic-data.user.service';

@Injectable({
    providedIn: 'root'
})
export class IcDataTeamService {
    private url: string;
    private teamOutStateData: any;
    private dataJSON: string;
    private uc: NICEUnavailableCode;
    private found: boolean;
    private addList: any[];
    private deleteList: any[];
    private teamFilterValue = '';


    constructor(
        public genHttp: GeneralService,
        public auth: AuthService,
        private _icUserData: IcDataUserService
    ) {
    }

    public updateTeamOutStates(id: string, data: string): Promise<NICETeamAgent> {
        return new Promise((resolve, reject) => {
            this.genHttp.icPut('baseURL/services/' + this.auth.apiVersion + '/teams/' + id + '/unavailable-codes', data)
                .pipe(map((response: any) => true))
                .subscribe((response: any) => {
                    resolve(response);
                }, reject);
        });
    }
    public getTeam(id: string): Promise<NICETeamAgent> {
        return new Promise((resolve, reject) => {
            this.genHttp.icGet('baseURL/services/' + this.auth.apiVersion + '/teams/' + id )
                .pipe(map((response: any) => new NICETeamAgent(response.teams[0])))
                .subscribe((response: NICETeamAgent) => {
                    resolve(response);
                }, reject);
        });
    }
    public getTeamNAgent(id: string): Promise<NICETeamAgent> {
        return new Promise((resolve, reject) => {
            this.genHttp.icGet('baseURL/services/' + this.auth.apiVersion + '/teams/' + id + '/agents?isActive=true')
                .pipe(map((response: any) => {
                    if (response !== null)
                    {
                        return new NICETeamAgent(response.teams[0]);
                    }
                    else {
                        return {agents: []};
                    }
                }))
                .subscribe((response: NICETeamAgent) => {
                    resolve(response);
                }, reject);
        });
    }

    public getTeamOutState(id: string): Promise<NICEUnavailableCode[]> {
        return new Promise((resolve, reject) => {
            this.genHttp.icGet('baseURL/services/' + this.auth.apiVersion + '/teams/' + id + '/unavailable-codes?activeOnly=true')
                .pipe(map((response: any) => {
                    const osList = response.unavailableCodes.map(data => new NICEUnavailableCode(data));
                    // this._teams.next(osList);
                    return osList;
                    //return new NICEUnavailableCode(response.unavailableCodes);
                }))
                .subscribe((response: NICEUnavailableCode[]) => {
                    resolve(response);
                }, reject);
        });
    }


    public deleteTeamOutState(id: string, originalList: NICEUnavailableCode[], newList: NICEUnavailableCode[]): Promise<any> {
        this.checkDeleteChange(originalList, newList);
        const data = '{"codes": ' + JSON.stringify(this.deleteList) + '}';

        return new Promise((resolve, reject) => {
            this.genHttp.icDelete('baseURL/services/' + this.auth.apiVersion + '/teams/' + id + '/unavailable-codes', data)
                .pipe(map((response: any) => true))
                .subscribe((response: any) => {
                    resolve(response);
                }, reject);
        });
    }
    public getSkillAssignments(skip?: number): Promise<NICEUserSkill[]> {
        const fields = 'skillName,skillID,agentId,teamId,agentProficiencyValue,isActive,agentName';
        let url = 'baseURL/services/' + this.auth.apiVersion +
            '/agents/skills?fields=' + encodeURIComponent(fields) + '&isSkillActive=true';
        url = url.concat('&skip=' + skip);
        return new Promise((resolve, reject) => {
            this.genHttp.icGet(url)
                .pipe(map((response: any) => response.agentSkillAssignments.map(data => new NICESkillAgent(data))))
                .subscribe((response: NICEUserSkill[]) => {
                    resolve(response);
                }, reject);
        });
    }


    public async getTeamSkillAssignments(teamId: number): Promise<NICEUserSkill[]> {
        const teamAgents = await this.getTeamNAgent(String(teamId));
        const skillAssignments: NICEUserSkill[] = [];
        for (const agent of teamAgents.agents) {
            if (agent.isActive) {
                const userAssignments = await this._icUserData.getAgentSkill(String(agent.agentId), '?isSkillActive=true');
                userAssignments.forEach((doc) => {
                    skillAssignments.push(doc);
                });
            }
        }

        return new Promise((resolve, reject) => {
            resolve(skillAssignments);
        });
    }



    public addTeamOutState(id: string,  originalList: NICEUnavailableCode[], newList: NICEUnavailableCode[]): Promise<any> {
        this.checkAddChange(originalList, newList);
        const data = '{"codes": ' + JSON.stringify(this.addList) + '}';

        return new Promise((resolve, reject) => {
            this.genHttp.icPost('baseURL/services/' + this.auth.apiVersion + '/teams/' + id + '/unavailable-codes', data)
                .pipe(map((response: any) => true))
                .subscribe((response: any) => {
                    resolve(response);
                }, reject);
        });
    }

    public checkOutStateChange(originalList: NICEUnavailableCode[], newList: NICEUnavailableCode[]): boolean {
        return this.checkAddChange(originalList, newList) && this.checkDeleteChange(originalList, newList);
    }

    checkDeleteChange(originalList: NICEUnavailableCode[], newList: NICEUnavailableCode[]): boolean {
        this.deleteList = [];

        for (const x of originalList) {
            this.found = false;
            for (const y of newList) {
                if (x.outStateId === y.outStateId) {
                    this.found = true;
                    break;
                }
            }
            if (!this.found) {
                this.deleteList.push({outstateId: x.outStateId.toString()});
            }
        }

        return (this.deleteList.length === 0);
    }

    checkAddChange(originalList: NICEUnavailableCode[], newList: NICEUnavailableCode[]): boolean {
        this.addList = [];
        for (const x of newList) {
            this.found = false;
            for (const y of originalList) {
                if (x.outStateId === y.outStateId) {
                    this.found = true;
                    break;
                }
            }
            if (!this.found) {
                this.addList.push({outstateId: x.outStateId});
            }
        }

        return (this.addList.length === 0);

    }
    public getUserFilter(): string {
        return this.teamFilterValue;
    }

    public putUserFiler(filter: string): void {
        this.teamFilterValue = filter;
    }

}
